"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = void 0;
const DoubleN = __importStar(require("double-n"));
const uom_1 = require("uom");
const bitPrecision = 40;
const compare = (a, b) => compareAmounts(a, b);
exports.compare = compare;
function compareAmounts(a, b) {
    const mostGranularUnit = uom_1.Amount.getMostGranularUnit(a.unit, b.unit);
    const decimalCount = Math.max(a.decimalCount, b.decimalCount);
    const valueA = uom_1.Amount.valueAs(mostGranularUnit, a);
    const valueB = uom_1.Amount.valueAs(mostGranularUnit, b);
    const f = Math.round(valueA * Math.pow(10, decimalCount));
    const s = Math.round(valueB * Math.pow(10, decimalCount));
    const f42 = DoubleN.numberToDoubleN(f, bitPrecision);
    const s42 = DoubleN.numberToDoubleN(s, bitPrecision);
    if (f42 === s42) {
        return 0;
    }
    if (f42 < s42) {
        return -1;
    }
    else {
        return 1;
    }
}
//# sourceMappingURL=amount-compare.js.map